var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.868,
    height: 22.338,
    viewBox: "0 0 17.868 22.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.887,
    y1: 0.705,
    x2: 0.24,
    y2: 0.418,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M2.365,22.338A2.384,2.384,0,0,1,0,19.916V8.343A2.384,2.384,0,0,1,2.365,5.921H15.5a2.384,2.384,0,0,1,2.365,2.422V19.916A2.384,2.384,0,0,1,15.5,22.338ZM5.177,10.415v2.046a.784.784,0,0,0,.788.807H11.9a.784.784,0,0,0,.788-.807V10.415a.789.789,0,1,0-1.577,0v1.238H6.754V10.415a.789.789,0,1,0-1.577,0ZM2.365,4.575a.784.784,0,0,1-.788-.807.784.784,0,0,1,.788-.808H15.5a.784.784,0,0,1,.789.808.784.784,0,0,1-.789.807Zm1.314-2.96A.785.785,0,0,1,2.89.807.784.784,0,0,1,3.679,0H14.19a.784.784,0,0,1,.788.807.784.784,0,0,1-.788.808Z",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.6f5cf9e508f2708519d84b950fe2576e.svg";
export { ForwardRef as ReactComponent };